import {Fragment} from 'react';
import {Vector3,Quaternion} from 'three';
import {ToggleButton, ToggleButtonGroup, Button, Dropdown, DropdownButton, Form, Row, Col, InputGroup} from 'react-bootstrap';
import {Trash,PlusCircle,XCircle,Eye,EyeSlash,PlayBtn,PauseBtn,PlusSquare,DashSquare,Circle,Grid3x3} from 'react-bootstrap-icons';
import RangeSlider from 'react-bootstrap-range-slider';
import {useHotkeys} from 'react-hotkeys-hook';

import {ModelLoader} from './modelLoader';
import {useAnimStore} from './index';

export const TopNav = (props) => {
  return  (
        <Fragment>
            {/*<span className="mx-2"></span>*/}
            <Button className="mx-2" variant="light" size="sm" onClick={()=>{props.setShowState(!props.showState)}}>Flexure Mobility Analysis (v{props.version})</Button>
            <ModelLoader className="mx-2" handleLoadModel={props.handleLoadModel} handleLoadFile={props.handleLoadFile} />
            <Button className="mx-2" onClick={props.handleSaveModel} size="sm" variant="outline-secondary">Save model</Button>
            <Button className="mx-2" onClick={()=>{props.setShowOrigin(!props.showOrigin)}} size="sm" variant="outline-secondary">{props.showOrigin ? "Hide origin" : "Show origin"}</Button>
            <Button className="mx-2" onClick={()=>{props.setShowNav(!props.showNav)}} size="sm" variant={props.showNav ? "outline-primary" : "primary"}>{props.showNav ? "Hide menu" : "Show menu"}</Button>
            <Button className="mx-2" onClick={()=>{props.setSignedIn(false)}} size="sm" variant="outline-secondary">Logout</Button>
        {/*<Col>
          <div class="d-block d-sm-none">xs</div>
          <div class="d-none d-sm-block d-md-none">sm</div>
          <div class="d-none d-md-block d-lg-none">md</div>
          <div class="d-none d-lg-block d-xl-none">lg</div>
          <div class="d-none d-xl-block">xl</div>
        </Col>*/}
        </Fragment>
        );
}

export function ElementNav(props) {
    //a note: on form.control, "defaultValue" won't update on state changes, "value" won't let you change the input field
    //"defaultValue" with some changing "key" does work as a hack: it updates upon state change
    const elementNav = props.elements.map(
        (e,i) =>{
          let locYform = e.locY[0].toFixed(1) + ', ' + e.locY[1].toFixed(1) + ', ' + e.locY[2].toFixed(1);

          return(
            <Row key={e.id} className={(props.activeElement && props.activeElementId === e.id) ? "align-items-center bg-light" : "align-items-center"}>
            <Col sm={1}>
              <Button 
                size="sm" 
                variant="light" 
                active={(props.activeElement && props.activeElementId === e.id) ? true : false} 
                onClick={()=>props.selectElement(e.id)}
              >
                {e.id}
              </Button>
            </Col>
            <Col sm={2}>{e.connect[0]}, {e.connect[1]}</Col>
            <Col sm={3} lg={4} xl={3}>
              {/*<Form onKeyPress={(e)=>{e.key==='Enter' && e.preventDefault();}} inline>
                <Form.Control className="w-100" type="text" placeholder="local-y" size="sm" name="locY1" key={locYform} defaultValue={locYform} onChange={(ev)=>props.changeLocY(ev,e.id)}/>
              </Form>*/}
              <Form onKeyPress={(ev)=>{
                  if(ev.key==='Enter') {
                    ev.preventDefault();
                    props.changeLocY(ev,e.id);
                  }
                }} inline>
                <Form.Control className="w-100" type="text" placeholder="local-y" size="sm" name="locY1" key={locYform} defaultValue={locYform} />
              </Form>
            </Col>
            {/*<Col>{e.locY.x.toFixed(1)}, {e.locY.y.toFixed(1)}, {e.locY.z.toFixed(1)}</Col>*/}
            <Col sm={4} className={"d-lg-none d-xl-block"}>
              {/*dont show for lg size*/}
              <ToggleButtonGroup name="elementRigid" size="sm" value={e.type}>
                <ToggleButton value="rigid" variant="outline-secondary" onClick={(ev)=>props.changeElementType(ev,e.id,'rigid')}>Rigid</ToggleButton>
                <ToggleButton value="leaf" variant="outline-secondary" onClick={(ev)=>props.changeElementType(ev,e.id,'leaf')}>Leaf</ToggleButton>
                <ToggleButton value="wire" variant="outline-secondary" onClick={(ev)=>props.changeElementType(ev,e.id,'wire')}>Wire</ToggleButton>
                <ToggleButton value="notch" variant="outline-secondary" onClick={(ev)=>props.changeElementType(ev,e.id,'notch')}>Notch</ToggleButton>
              </ToggleButtonGroup>
            </Col>  
            <Col lg={3} className={"d-none d-lg-block d-xl-none"}>
                {/*only show for lg size*/}
                <DropdownButton title={capitalizeFirstLetter(e.type)} size="sm" variant="outline-secondary" onSelect={(ev)=>props.changeElementType('',e.id,ev)}>
                  <Dropdown.Item eventKey={'rigid'} active={e.type === 'rigid' ? true : false}>Rigid</Dropdown.Item>
                  <Dropdown.Item eventKey={'leaf'} active={e.type === 'leaf' ? true : false}>Leaf</Dropdown.Item>
                  <Dropdown.Item eventKey={'wire'} active={e.type === 'wire' ? true : false}>Wire</Dropdown.Item>
                  <Dropdown.Item eventKey={'notch'} active={e.type === 'notch' ? true : false}>Notch</Dropdown.Item>
                </DropdownButton>
            </Col>
            <Col sm={1}><Button size="sm" variant="light" onClick={()=>props.deleteElement(e.id)}><Trash /></Button></Col>
            </Row>
          )
        }
    )
    return (
    <Fragment>
    <Row>
      <Col sm={1}>ID</Col>
      <Col sm={2}>Nodes</Col>
      <Col sm={3} lg={4} xl={3}>Orientation</Col>
      <Col sm={4} lg={3} xl={4}>Type</Col>
      <Col sm={1}>Del.</Col>
    </Row>
    {elementNav}
    </Fragment>
    )
}

export function PlaneNav(props) {
    console.log('planes')
    console.log(props.planes)

  const planeNav = props.planes.map(
    (p) => {
      let dir = new Vector3();

      //just because of the old definition of plane orientation
      //old library models may not have the orien field
      if (p.orien !== undefined){ 
        dir = new Vector3(0,1,0).applyQuaternion(new Quaternion().fromArray(p.orien));
      } else {
        dir = new Vector3().fromArray(p.dir);
      }
      let dirFormatted = dir.x.toFixed(1) + ', ' + dir.y.toFixed(1) + ', ' + dir.z.toFixed(1);
      let type = 'cart';
      if (p.type !== undefined){
        type = p.type;
      }

      return (
          <Row key={p.id} className={(props.activePlane && props.activePlaneId === p.id) ? "align-items-center bg-light" : "align-items-center"}>
            <Col sm={1}>
              <Button size="sm" variant="light" active={(props.activePlane && props.activePlaneId === p.id) ? true : false} onClick={()=>props.selectPlane(p.id)}>{p.id}</Button>
            </Col>
            <Col sm={2}>{Math.floor(p.center[0])}, {Math.floor(p.center[1])}, {Math.floor(p.center[2])}</Col>
            {/*<Col sm={3}>{dirFormatted}</Col>*/}
            <Col sm={3}>
              <Form onKeyPress={(ev)=>{
                  if(ev.key==='Enter') {
                    ev.preventDefault();
                    props.changeDir(ev,p.id)
                  }
                }} inline>
                <Form.Control className="w-100" type="text" placeholder="normal" size="sm" name="dir" key={dirFormatted} defaultValue={dirFormatted} />
              </Form>
              {/*<Form onKeyPress={(e)=>{e.key==='Enter' && e.preventDefault();}} inline>
                <Form.Control className="w-100" type="text" placeholder="normal" size="sm" name="dir" key={dirFormatted} defaultValue={dirFormatted} onChange={(ev)=>props.changeDir(ev,p.id)}/>
              </Form>*/}
            </Col>
            <Col sm={2}>
              <ToggleButtonGroup name="show" size="sm" value={type}>
                <ToggleButton value="cart" variant="outline-secondary" onClick={(ev)=>props.changePlaneType(ev,p.id,'cart')}><Grid3x3 /></ToggleButton>
                <ToggleButton value="polar" variant="outline-secondary" onClick={(ev)=>props.changePlaneType(ev,p.id,'polar')}><Circle /></ToggleButton>
              </ToggleButtonGroup>
            </Col>
            <Col sm={2}>
{/*              <Button size="sm" variant="light" onClick={()=>props.togglePlaneVisibility(p.id)}>
              { p.show && <EyeSlash />}
              { !p.show && <Eye />}
              </Button>*/}
              <ToggleButtonGroup name="show" size="sm" value={p.show ? "show" : "hide"}>
                <ToggleButton value="show" variant="outline-secondary" onClick={()=>props.togglePlaneVisibility(p.id,true)}><Eye /></ToggleButton>
                <ToggleButton value="hide" variant="outline-secondary" onClick={()=>props.togglePlaneVisibility(p.id,false)}><EyeSlash /></ToggleButton>
              </ToggleButtonGroup>
            </Col>
            <Col sm={1}>
              <Button size="sm" variant="light" onClick={()=>props.deletePlane(p.id)}>
                { p.id === 1 && <XCircle /> }
                { p.id > 1 && <Trash /> }
              </Button>
            </Col>
          </Row>
      )
    }
  );

  return (
    <Fragment>
    <Row>
    <Col xs={3}>
        <ToggleButtonGroup name="analysisType" size="sm" value={props.transformGridType}>
          <ToggleButton value="translate" variant="outline-secondary" onClick={(ev)=>props.changeTransformGridType(ev,'translate')}>Translate</ToggleButton>
          <ToggleButton value="rotate" variant="outline-secondary" onClick={(ev)=>props.changeTransformGridType(ev,'rotate')}>Rotate</ToggleButton>
        </ToggleButtonGroup>
      </Col>
    </Row>
    <Row>&nbsp;</Row>
    <Row>
      <Col xs={1}>ID</Col>
      <Col xs={2}>Position</Col>
      <Col xs={3}>Normal vector</Col>
      <Col xs={2}>Type</Col>
      <Col xs={2}>Visibility</Col> 
      <Col xs={1}>Del.</Col>     
    </Row>
    {planeNav}
    <Row>&nbsp;</Row>
    <Row>
      <Col sm={5}><Button size="sm" variant="light" onClick={()=>props.addPlane()}><PlusCircle /> Add new plane</Button></Col>
    </Row>
    </Fragment>
  )
}
    
export function NodeNav(props) {

  const nodeNav = props.nodes.map(
    (n,i) => {

      const attached = props.elements.some(e => (e.connect[0] === n.id || e.connect[1] === n.id));

      return(
          <Row key={n.id} className={(props.activeNode && props.activeNodeId === n.id) ? "align-items-center bg-light" : "align-items-center"}>
            <Col sm={1}>
              <Button size="sm" variant="light" active={(props.activeNode && props.activeNodeId === n.id) ? true : false} onClick={()=>props.selectNode(n.id)}>{n.id}</Button>
            </Col>
            <Col sm={4} xl={3}>{Math.floor(n.coord[0])}, {Math.floor(n.coord[1])}, {Math.floor(n.coord[2])}</Col>
            <Col sm={3} lg={5} xl={4}>
              <ToggleButtonGroup name="nodeBC" size="sm" value={n.fix ? "fixed" : "free"}>
                <ToggleButton value="free" variant="outline-secondary" onClick={(ev)=>props.changeFix(ev,n.id,'free')}>Free</ToggleButton>
                <ToggleButton value="fixed" variant="outline-secondary" onClick={(ev)=>props.changeFix(ev,n.id,'fixed')}>Fixed</ToggleButton>
              </ToggleButtonGroup>
            </Col>
            <Col sm={1}><Button size="sm" variant="light" onClick={()=>props.deleteNode(n.id)} disabled={attached ? true : false}><Trash /></Button></Col>
          </Row>
      )
    }
  )

  return (
    <Fragment>
    <Row>
      <Col sm={1}>ID</Col>
      <Col sm={4} xl={3}>Coordinates</Col>
      <Col sm={3} lg={5} xl={4}>Boundary condition</Col>
      <Col sm={1}>Del.</Col>
    </Row>
    {nodeNav}
    </Fragment>
  )

}

export const AnalysisNav = (props) => {
  
  const res = props.analysisRes;

  //animation store, getting access to the show and toggle variables (for animating underconstraints)
  const show = useAnimStore(state => state.show);
  const toggle = useAnimStore(state => state.toggle);

  if (!props.hasAnalyzed || res == null){
    return null;
  }

  if (res.status !== 'success'){
    switch (res.status){
      case 'nofreecoord':
        return <p>No free coordinates.</p>
      case 'nofixes':
        return <p>No fixed coordinates.</p>
      case 'noconstrdef':
        return <p>No constraints detected. </p>
      default:
        return <p>No analysis could be performed. See console.</p>
    }
  }

  //format singular values
  // const singval = res.singval.map(sv => sv.toFixed(2)).join(' ');

  const incrementOC = () => {
    //ugly way to reuse the already existing selectOC function:
    //let's make the object the selectOC function is expecting
    //(from the browser's event handler after a submitted form)
    let e = {target:{value:props.activeOCId+2}}; //activeOCId+1 is the currently visible OC, so increment by one
    props.selectOC(e)
  }

  const decrementOC = () => {
    let e = {target:{value:props.activeOCId}};
    props.selectOC(e)
  }

  const incrementUC = () => {
    let e = {target:{value:props.activeUCId+2}};
    props.selectUC(e)
  }

  const decrementUC = () => {
    let e = {target:{value:props.activeUCId}};
    props.selectUC(e)
  }

  return (
    <Fragment>
    <Row>Analysis results</Row>
    {/*<Row>
      <Col>Dcc size</Col>
      <Col>{res.nrows} by {res.ncols}</Col></Row>
    <Row>
      <Col>Singular values</Col>
      <Col>{singval}</Col></Row>
    <Row>
      <Col>Near-zero indices</Col>
      <Col>{res.nearzero_i}</Col></Row>
    <Row>
      <Col>Number of near-zero sv</Col>
      <Col>{res.nsing}</Col></Row>*/}
    <Row>
      <Col sm={4}>Number of overconstraints</Col>
      <Col>{res.nover}</Col></Row>
    <Row>
      <Col sm={4}>Number of DOFs (underconstraints)</Col>
      <Col>{res.nunder}</Col></Row>
    <Row>&nbsp;</Row>
    <Row>Visualization</Row>
    <Row>
        <Col sm={4}>Type</Col>
        <Col>
          <ToggleButtonGroup name="analysisType" size="sm" value={props.analysisType}>
            <ToggleButton value="overconstraints" variant="outline-secondary" onClick={(ev)=>props.changeAnalysisType(ev,'overconstraints')}>Overconstraints</ToggleButton>
            <ToggleButton value="underconstraints" variant="outline-secondary" onClick={(ev)=>props.changeAnalysisType(ev,'underconstraints')}>Underconstraints</ToggleButton>
          </ToggleButtonGroup>
        </Col>
    </Row>
    <Row>&nbsp;</Row>
    <Row>
        <Col sm={4}>Sparsify algorithm (LUQ)</Col>
        <Col>
          <ToggleButtonGroup name="analysisType" size="sm" value={props.doLUQ ? 'yes' : 'no'}>
            <ToggleButton value="yes" variant="outline-secondary" onClick={(ev)=>props.changeDoLUQ(ev,true)}>Enable</ToggleButton>
            <ToggleButton value="no" variant="outline-secondary" onClick={(ev)=>props.changeDoLUQ(ev,false)}>Disable</ToggleButton>
          </ToggleButtonGroup>
        </Col>
    </Row>  
    <Row>&nbsp;</Row>
    {
      props.analysisType === 'overconstraints' &&
      res.nover>0 &&
      <Fragment>
      {/*<Row>
        <Col sm={5}>Showing overconstraint</Col>
        <Col>{props.activeOCId+1}</Col>
      </Row>
      <Row>&nbsp;</Row>*/}
        <Row>
          <Col sm={4}>Change active overconstraint</Col>
          <Col>
            <InputGroup>
            <Form 
              onKeyPress={(ev)=>{
                  if(ev.key==='Enter') {
                    ev.preventDefault();
                    props.selectOC(ev)
                  }
                }} 
              inline
            >
              <Button size="sm" variant="light" id="button-decr" onClick={decrementOC} disabled={props.activeOCId>0?false:true}><DashSquare /></Button>
              <Form.Control className="w-25" type="text" placeholder="overc" size="sm" name="OC" key={props.activeOCId+1} defaultValue={props.activeOCId+1} aria-label="Decrement" aria-describedby="button-decr" />
              <Button size="sm" variant="light" id="button-decr" onClick={incrementOC} disabled={props.activeOCId+2>res.nover?true:false}><PlusSquare /></Button>
            </Form>
            </InputGroup>
          </Col>
        </Row>
      <Row>&nbsp;</Row>
      {/*<Row>
        <Col>Stress mode</Col>
        <Col>
          <ToggleButtonGroup name="stressMode" size="sm" value={props.stressMode}>
            <ToggleButton value="forces" variant="outline-secondary" onClick={(ev)=>props.changeStressMode(ev,'forces')}>Forces</ToggleButton>
            <ToggleButton value="moments" variant="outline-secondary" onClick={(ev)=>props.changeStressMode(ev,'moments')}>Moments</ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>*/}
      {/*<Row>&nbsp;</Row>*/}
      <Row><Col>Color legend</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "yellow"}} sm={1}></Col><Col>Pure axial force constraint</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "blue"}} sm={1}></Col><Col>Pure bending moment constraint</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "lightgreen"}} sm={1}></Col><Col>Transverse force constraint (center)</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "darkgreen"}} sm={1}></Col><Col>Transverse force constraint (off-center)</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "red"}} sm={1}></Col><Col>Combined loads</Col></Row>
      <Row><Col sm={1}>&nbsp;</Col><Col style={{backgroundColor: "lightgrey"}} sm={1}></Col><Col>No stress</Col></Row>
      </Fragment>
    }
    {
      props.analysisType === 'underconstraints' &&
      res.nunder>0 &&
      <Fragment>
        {/*<Row>
          <Col sm={5}>Showing underconstraint</Col>
          <Col>{props.activeUCId+1}</Col></Row>
        <Row>&nbsp;</Row>*/}
          <Row>
            <Col sm={4}>Change active underconstraint</Col>
              <Col>
                <InputGroup>
                <Form 
                  onKeyPress={(ev)=>{
                      if(ev.key==='Enter') {
                        ev.preventDefault();
                        props.selectUC(ev)
                      }
                    }} 
                  inline
                >
                  <Button size="sm" variant="light" id="button-decr" onClick={decrementUC} disabled={props.activeUCId>0?false:true}><DashSquare /></Button>
                  <Form.Control className="w-25" type="text" placeholder="overc" size="sm" name="OC" key={props.activeUCId+1} defaultValue={props.activeUCId+1} />
                  <Button size="sm" variant="light" id="button-decr" onClick={incrementUC} disabled={props.activeUCId+2>res.nunder?true:false}><PlusSquare /></Button>
                </Form>
                </InputGroup>
              </Col>
          </Row>
          <Row>&nbsp;</Row>
          <Row>
            <Col sm={4}>Animate underconstraint</Col>
            <Col sm={1}>
                  <Button size="sm" variant="light" onClick={toggle}>
                    {!show && <PlayBtn />}
                    {show && <PauseBtn />}
                  </Button>    
            </Col>
          </Row>
      </Fragment>
    }
    </Fragment>
  )

}

export function TrajectoryNav(props) {

  const lstep = useAnimStore(state => state.lstep);
  const show = useAnimStore(state => state.show);
  const toggle = useAnimStore(state => state.toggle);
  const explode = useAnimStore(state => state.explode);
  const setExplode = useAnimStore(state => state.setExplode);
  const setLoadstep = useAnimStore(state => state.setLoadstep);

  const steps = props.elements[0].traj.rp.length

  return (
      <Fragment>
        <Row>
          <Col sm={2}>
            {lstep}
          </Col>
          <Col sm={3}>
            <RangeSlider value={lstep} min={0} max={steps-1} step={1} tooltip={'off'} onChange={(e) => setLoadstep(e.target.value)} />
          </Col>
          <Col>
            <Button size="sm" variant="light" onClick={toggle}>
              {!show && <PlayBtn />}
              {show && <PauseBtn />}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm={2}>
            {explode}
          </Col>
          <Col>
            <RangeSlider value={explode} min={0} max={500} step={10} tooltip={'off'} onChange={(e) => setExplode(e.target.value)} />
          </Col>
        </Row>
      </Fragment>
  )

}

export function Nav(props) {
  const handleChange = (e,val) => {
    props.onModeChange(val);
    if (e !== ''){
      //stupid thing: necessary because browser may add focus on buttons after clicking,
      // preventing the use of the hotkeys we're setting below
      e.target.blur();
      e.preventDefault();

    }
  }
  
  // const handleDelete = () => {
  //   props.onDelete();
  // }

  //callback function in useHotkeys gets memoised, so need to specify a dependency array to avoid "stale state".
  const dep = [props.mode];
  useHotkeys("p", (e)=>handleChange(e,'planes'), dep);
  useHotkeys("n", (e)=>handleChange(e,'nodes'), dep);
  useHotkeys("e", (e)=>handleChange(e,'elements'), dep);
  useHotkeys("a", (e)=>handleChange(e,'analyze'), dep);
  // useHotkeys("del", ()=>handleDelete(), dep);

  let showTraj = false;
  if(props.elements.length>0 && props.elements[0].hasOwnProperty('traj')){
    showTraj = true;
  }
  
  return(
    <ToggleButtonGroup name='mode' value={props.mode}>
      <ToggleButton value='planes' variant='outline-primary' onClick={(e)=>handleChange(e,'planes')}>Planes</ToggleButton>
      <ToggleButton value='nodes' variant='outline-primary' onClick={(e)=>handleChange(e,'nodes')}>Nodes</ToggleButton>
      <ToggleButton value='elements' variant='outline-primary' onClick={(e)=>handleChange(e,'elements')}>Elements</ToggleButton>
      <ToggleButton value='analyze' variant='outline-dark' onClick={(e)=>handleChange(e,'analyze')}>Analyze</ToggleButton>
      {showTraj && <ToggleButton value='trajectory' variant='outline-dark' onClick={(e)=>handleChange(e,'trajectory')}>Trajectory</ToggleButton>}
    </ToggleButtonGroup>
  )
}

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}